import React from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import CardList from './CardList';

const Dashboard = () => {
  return (
    <>
        <Sidebar/>
        <Navbar/>
        <CardList/>
    </>
  )
}

export default Dashboard;
